import MemiconData from './memicon.json'
import GuynColors from 'guyn/guyn/json/guyn.json'
import { Touch, Arrays, Tiles, Numbers } from '../../mixins'
export default {
	mixins: [Touch, Arrays, Tiles, Numbers],
	computed: {
		gameMenu: {
			get() {
				return this.$store.state.ui.menu
			},
			set(bool) {
				this.$store.dispatch('ui/setMenu', bool)
			},
		},
		gameMode: {
			get() {
				return this.$store.state.game.mode
			},
			set(mode) {
				this.$store.dispatch('game/setMode', mode)
			},
		},
		gameTheme: {
			get() {
				return this.$store.state.game.theme
			},
			set(theme) {
				this.$store.dispatch('game/setTheme', theme)
			},
		},
		availableThemes() {
			if (
				this.settings &&
				this.settings.themes &&
				Object.keys(this.gameMode).length > 0
			) {
				return this.settings.themes.filter(theme => {
					return (
						(this.gameMode.columns[0] * this.gameMode.columns[1]) /
							2 <=
						theme.emoji.length
					)
				})
			} else {
				return []
			}
		},
	},
	data: () => ({
		settings: { ...MemiconData },
		canvas: null,
		ctx: null,
		window: {},
		tileType: 'farmAnimals',
		touchDevice: true,
		current: {
			open: [],
			init: false,
			started: false,
			checking: false,
			won: false,
			steps: 0,
			points: 0,
		},
		timer: {
			show: 3000,
		},
		tileSet: [],
		tiles: [],
		tile: {
			column: {
				x: 0,
				y: 0,
			},
			margin: 1,
			width: 0,
			height: 0,
		},
		listeners: {
			clickTouch: null,
			clickMouse: null,
			resize: null,
		},
	}),

	watch: {
		tiles: {
			handler: function() {
				if (this.current.steps > 1) {
					this.checkWinning()
				}
			},
			deep: true,
		},
	},
	methods: {
		/*

			Simple navigation functions
		
		*/
		back() {
			this.gameMenu = true
			this.current.won = false
		},
		play() {
			this.tileSet = []
			this.tiles = []
			this.current = {
				init: false,
				started: false,
				open: [],
				checking: false,
				won: false,
				steps: 0,
				points: 0,
			}
			setTimeout(() => {
				this.init()
				this.$store.dispatch('ui/setMenu', false)
			}, 10)
		},
		init() {
			// this.touchDevice = this.isTouchDevice();
			this.buildCanvas()
			this.createTileSet()
			this.buildTiles()

			this.current.session = Date.now()
			this.current.loading = true
			this.current.init = true
			setTimeout(() => {
				if (!this.current.started) {
					this.closeAllTiles()
					this.current.started = true
					this.current.loading = false
				}
			}, this.timer.show)

			this.loop()
			this.saveGame()
		},

		/*

			Tiles

		*/

		findTile(Y, X) {
			let currentTile
			for (let t = 0; t < this.tiles.length; t++) {
				let tile = this.tiles[t]

				let xRange = [tile.x, tile.x + tile.width]
				let yRange = [tile.y, tile.y + tile.height]

				if (
					Y > yRange[0] &&
					Y < yRange[1] &&
					X > xRange[0] &&
					X < xRange[1]
				) {
					currentTile = tile
				}
			}
			// Check if the current tile exists, and if its not already in the open tiles.
			if (currentTile && !this.current.open.includes(currentTile.id))
				return currentTile
			else return false
		},
		shakeTile(tile) {
			let og = {
				x: tile.x,
				y: tile.y,
			}
			setTimeout(() => {
				tile.x = og.x + this.tile.margin / 2
				setTimeout(() => {
					tile.x = og.x - this.tile.margin / 2
					setTimeout(() => {
						setTimeout(() => {
							tile.x = og.x + this.tile.margin / 2
							setTimeout(() => {
								tile.x = og.x - this.tile.margin / 2
								setTimeout(() => {
									tile.x = og.x
								}, 50)
							}, 50)
						}, 50)
					}, 50)
				}, 50)
			}, 50)
		},

		rotateTile(tile, status) {
			//Don't do anything when the status is already set correctly.
			if (tile.status == status) return

			let steps = 0
			let totalSteps = 30
			let interval = setInterval(() => {
				steps++
				tile.rotation = (90 / totalSteps) * steps

				tile.scaleX =
					Math.round(Math.abs((2 / totalSteps) * steps - 1) * 100) /
					100
				tile.scaleY =
					Math.round(Math.abs((2 / totalSteps) * steps - 1) * 100) /
						100 /
						4 +
					0.75

				if (steps == Math.round(totalSteps / 2)) {
					tile.status = status
				} else if (steps == totalSteps) {
					clearInterval(interval)
					tile.rotation = null
				}
			}, 10)
		},
		createTileSet() {
			// Create the set
			let currentSet = []

			// Load the set and shuffe, so you will get different emoji every time.
			let emojiSet = this.shuffle(this.gameTheme.emoji)

			// GO through every number which should be filled
			for (let e = 0; e < this.tile.total / 2; e++) {
				currentSet.push({ emoji: emojiSet[e] })
				currentSet.push({ emoji: emojiSet[e] })
			}
			// Shuffle the set obviously
			currentSet = this.shuffle(currentSet)

			// And add them to the tileset
			for (let t = 0; t < this.tile.total; t++) {
				this.tileSet.push({
					status: 0,
					emoji: currentSet[t].emoji,
				})
			}
		},

		closeAllTiles() {
			for (let t = 0; t < this.tiles.length; t++) {
				setTimeout(() => {
					this.rotateTile(this.tiles[t], 0)
				}, (1500 / this.tile.total) * t)
			}
		},
		closeTiles() {
			for (let t = 0; t < this.tiles.length; t++) {
				if (this.tiles[t].status < 2) this.rotateTile(this.tiles[t], 0)
			}
			this.current.open.length = 0
		},

		buildCanvas() {
			this.canvas = document.querySelector('#game')
			this.ctx = this.canvas.getContext('2d')
			this.window = {
				width: window.innerWidth,
				height: window.innerHeight,
			}

			// Set Size of Cnavas
			this.canvas.width = this.window.width
			this.canvas.height = this.window.height

			this.gridWidth = (this.window.width / 4) * 3
			this.gridHeight = (this.window.height / 4) * 3

			if (window.innerWidth < 768) {
				this.tile.margin = this.gridWidth / 25
			} else {
				this.tile.margin = this.gridWidth / 50
			}

			if (window.innerWidth > window.innerHeight) {
				this.orientation = 'landscape'
				this.tile.column.x = Math.max(...this.gameMode.columns)
				this.tile.column.y = Math.min(...this.gameMode.columns)

				this.tile.width =
					this.gridWidth / this.tile.column.x - this.tile.margin
				this.tile.height = this.tile.width

				this.gridHeight = this.tile.height * this.tile.column.y
			} else {
				this.orientation = 'portrait'
				this.tile.column.x = Math.min(...this.gameMode.columns)
				this.tile.column.y = Math.max(...this.gameMode.columns)

				this.tile.width =
					this.gridWidth / this.tile.column.x - this.tile.margin
				this.tile.height = this.tile.width

				this.gridHeight = this.tile.height * this.tile.column.y
			}

			this.tile.total = this.tile.column.x * this.tile.column.y
		},
		getColor(value) {
			let colorName = this.gameTheme.colors[value]
			return GuynColors[colorName]
		},

		renderTiles() {
			this.ctx.beginPath()
			for (let t = 0; t < this.tiles.length; t++) {
				this.renderTile(this.tiles[t])
			}
		},
		renderTile(tile) {
			this.ctx.clearRect(
				tile.x - this.tile.margin / 2,
				tile.y - this.tile.margin / 2,
				tile.width + this.tile.margin + 2,
				tile.height + this.tile.margin + 2
			)

			if (tile.scaleX && tile.scaleY) {
				this.ctx.translate(
					tile.x + tile.width / 2,
					tile.y + tile.height / 2
				)

				this.ctx.scale(tile.scaleX, tile.scaleY)
				this.ctx.translate(
					(tile.width / 2) * -1,
					(tile.height / 2) * -1
				)
			} else {
				this.ctx.translate(tile.x, tile.y)
			}

			/* eslint-disable */
			switch (tile.status) {
				// Hidden

				case 0:
					this.ctx.fillStyle = this.getColor('tileClosed')
					this.ctx.shadowColor = this.getColor('tileClosedShadow')
					this.ctx.shadowOffsetY = 6
					break

				// Show
				case 1:
					this.ctx.fillStyle = this.getColor('tileOpen')
					this.ctx.shadowColor = this.getColor('tileOpenShadow')
					this.ctx.shadowOffsetY = 6
					break

				// Done
				case 2:
					this.ctx.fillStyle = this.getColor('tileDone')
					this.ctx.shadowColor = this.getColor('tileDoneShadow')
					this.ctx.shadowOffsetY = 6
					break

				// Won
				case 3:
					this.ctx.fillStyle = this.getColor('tileFinished')
					this.ctx.shadowColor = this.getColor('tileFinishedShadow')
					this.ctx.shadowOffsetY = 6
					break
			}
			/* eslint-enable */

			this.ctx = this.roundRect(this.ctx, 0, 0, tile.width, tile.height)

			this.ctx.fill()

			// this.ctx.fillRect(posLeft, posTop, this.tile.width, this.tile.height);
			if (tile.status > 0) {
				this.ctx.font = `${tile.width / 2}px serif`

				// use these alignment properties for "better" positioning
				this.ctx.textAlign = 'center'
				this.ctx.textBaseline = 'middle'
				this.ctx.shadowColor = `rgba(0,0,0,0)`
				this.ctx.shadowOffsetY = 0
				// draw the emoji
				this.ctx.fillText(
					tile.emoji,
					0 + tile.width / 2,
					0 + tile.height / 2
				)
			}
			this.ctx.setTransform(1, 0, 0, 1, 0, 0)

			return tile
		},
		buildTiles() {
			// Set some variables
			let posTop = 0
			let posLeft = 0
			let t = 0
			let tiles = []

			// Build Row
			for (let c = 0; c < this.tile.column.x; c++) {
				// Build Column
				for (let r = 0; r < this.tile.column.y; r++) {
					let xx = (this.canvas.width - this.gridWidth) / 2
					let yy = (this.canvas.height - this.gridHeight) / 2
					posTop = yy + r * (this.tile.height + this.tile.margin)
					posLeft = xx + c * (this.tile.width + this.tile.margin)

					let tile = this.tileSet[t]

					tiles.push({
						id: t,
						x: posLeft,
						y: posTop,
						width: this.tile.width,
						height: this.tile.height,
						emoji: tile.emoji,
						status: 2,
					})
					t++
				}
			}
			this.tiles = tiles
		},

		/*
			Checks
		*/

		checkWinning() {
			// Don't have to check twic..
			if (this.current.checking) return

			this.current.checking = true

			// Set it to winning
			let winning = true

			// Go through all tiles and check if all tiles are done.
			for (let t = 0; t < this.tiles.length; t++) {
				if (this.tiles[t].status < 2) winning = false
			}

			// If we are winning, get all tiles to status 3.
			if (winning) {
				this.saveGame(true)
				for (let t = 0; t < this.tiles.length; t++) {
					setTimeout(() => {
						this.rotateTile(this.tiles[t], 3)
					}, 100 * t + 500)
					if (t == this.tiles.length - 1) {
						setTimeout(() => {
							this.current.won = true
						}, 500)
					}
				}
			} else {
				this.saveGame()
				this.current.checking = false
			}
			return winning
		},

		checkTiles() {
			let tile1 = this.tiles.find(tile => {
				return tile.id == this.current.open[0]
			})
			let tile2 = this.tiles.find(tile => {
				return tile.id == this.current.open[1]
			})
			if (tile1.emoji == tile2.emoji) {
				this.current.points = this.current.points + 8
				this.current.open.length = 0
				setTimeout(() => {
					tile1.status = 2
					// this.rotateTile(tile1, 2);
					setTimeout(() => {
						tile2.status = 2
						// this.rotateTile(tile2, 2);
					}, 250)
				}, 750)
			} else {
				setTimeout(() => {
					this.shakeTile(tile1)
					this.shakeTile(tile2)
					setTimeout(() => {
						this.closeTiles()
					}, 800)
				}, 500)
			}
		},

		/*
		
			Game logic

		*/

		randomQuote() {
			const quotes = ['You won!', 'Good job!', 'Nice work!', 'Well done!']
			return quotes[this.Random(0, quotes.length)]
		},

		saveGame(done = false) {
			let time = Date.now()

			let session = {
				session: this.current.session,
				active: done,
				steps: this.current.steps,
				score: this.current.points,
				time: time.toString(),
			}
			this.$store.dispatch('highscore/setSession', session)
		},

		handleClick(e) {
			if (!this.current.started) {
				this.closeAllTiles()
				this.current.started = true
				this.current.loading = false
				return false
			}
			let tile
			if (e['targetTouches']) {
				tile = this.findTile(
					e['targetTouches'][0]['clientY'],
					e['targetTouches'][0]['clientX']
				)
			} else {
				tile = this.findTile(e.clientY, e.clientX)
			}
			if (!tile) return
			if (tile.status > 1) return

			if (this.current.open.length < 2) {
				this.current.open.push(tile.id)
				this.rotateTile(tile, 1)
			}

			if (this.current.open.length == 2) {
				this.checkTiles()
			}

			this.current.steps = this.current.steps + 1
			this.current.points = this.current.points - 1
			this.saveGame()
		},

		loop() {
			this.renderTiles()
			window.requestAnimationFrame(() => {
				this.loop()
			})
		},
	},
	mounted() {
		if (!this.isTouchDevice())
			this.listeners.clickMouse = window.addEventListener(
				'mouseup',
				e => {
					this.handleClick(e)
				}
			)
		if (this.isTouchDevice())
			this.listeners.clickTouch = window.addEventListener(
				'touchstart',
				e => {
					this.handleClick(e)
				}
			)
		this.listeners.resize = window.addEventListener('resize', () => {
			this.buildCanvas()
		})
	},
}
